import React from "react";
import { CopyrightIcon } from "@sscs/ui/icons";
import styles from "./copyleftIcon.module.scss";
const CopyleftIcon = ({ className }) => {
    return (React.createElement("div", { className: styles["copyleft-icon"] },
        React.createElement(CopyrightIcon, { className: className })));
};
export default CopyleftIcon;
//# sourceMappingURL=CopyleftIcon.js.map